export const OutcomeTypes = Object.freeze({
    Yes: 'yes',
    No: 'no',
    Maybe: 'maybe'
});
